import { CSSProperties } from 'react'
import styled from 'styled-components'

import ClockIcon from 'components/icons/Clock'

const Outer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px;

  color: ${({ theme }) => theme?.['-ds-success-300']?.value};
  background-color: ${({ theme }) => theme?.['-ds-success-100']?.value};

  border: 1px solid ${({ theme }) => theme?.['-ds-success-200']?.value};
  border-radius: 4px;

  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxs']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.4;

  svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme?.['-ds-success-200']?.value};
    width: 15px;
    height: 15px;
    margin-top: 2px;
    margin-right: 10px;
  }
`

type Props = {
  style?: CSSProperties
}

const AvailabilityAlert = ({ style }: Props) => {
  return (
    <Outer style={style}>
      <ClockIcon />
      <span>
        <strong>Don’t snooze!</strong> This is usually booked.
      </span>
    </Outer>
  )
}

export default AvailabilityAlert
